import { render } from "./TaskDetailsLoader.vue?vue&type=template&id=1dbf81c6"
const script = {}

import exportComponent from "/var/lib/jenkins/workspace/ignis-front-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__